import forEach from 'lodash/forEach';

/**
 * @visibleName forEach
 * @since 0.22.0
 * @component
 */
export default forEach;
